// 處理網址的預設方法
// const getUrlString = location.href;
// const url = new URL(getUrlString);

// 所有特效都會放在這邊
const initState = {
  isLoading: false,
  isShowModal: false,
  isShowExceptionModal: false,
  apiExceptionMessage: '',
};

export function commonState(state = initState, action) {
  switch (action.type) {
    case 'CHANGE_EFFECT_ISLOADING': {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case 'CHANGE_MODAL_SHOW': {
      return {
        ...state,
        isShowModal: action.payload,
      };
    }
    case 'SHOW_EXCEPTION_MODAL': {
      return {
        ...state,
        isShowExceptionModal: true,
      };
    }
    case 'CLOSE_EXCEPTION_MODAL': {
      return {
        ...state,
        isShowExceptionModal: false,
      };
    }
    case 'UPDATE_API_RESPONSE_MESSAGE': {
      return {
        ...state,
        apiExceptionMessage: action.payload,
      };
    }
    default:
      return state;
  }
}

export default commonState;
